"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const BaseListBox_1 = tslib_1.__importDefault(require("./BaseListBox"));
/**
 * @deprecated use {@link UngroupedDropdownWidget} or {@link GroupedDropdownWidget} instead.
 */
class TypedListBox extends BaseListBox_1.default {
    constructor(element) {
        super(element);
    }
    setOptions(options) {
        const selected = this.getValue();
        this.options = [...options];
        while (this.element.firstChild) {
            this.element.removeChild(this.element.firstChild);
        }
        if (this.model.getTextForNoOptionSelected()) {
            const option = document.createElement("option");
            this.element.appendChild(option);
            option.text = this.model.getTextForNoOptionSelected();
            this.itemOffset = 1;
        }
        else {
            this.itemOffset = 0;
        }
        for (const option of this.options) {
            const optionElement = document.createElement("option");
            this.element.appendChild(optionElement);
            optionElement.value = this.model.formatItem(option);
            fmko_ts_common_1.HTMLUtils.setSanitizedHTML(optionElement, this.model.formatItem(option));
        }
        if (selected) {
            this.setValue(selected);
            // Either the function doesn't exist or the new function is used and should be checked
        }
        else if (options.length === 1 && (!this.model.selectIfSingleOption || this.model.selectIfSingleOption())) {
            this.setValue(options[0]);
        }
    }
}
exports.default = TypedListBox;
//# sourceMappingURL=TypedListBox.js.map